import { defineStore } from 'pinia'
import type { Helpdesk, Language } from '~/types'

export const useHelpdeskStore = defineStore('helpdesk', {
    state: () => ({
        helpdesk: [] as Helpdesk[],
        currentHelpdesk: null as Helpdesk | null,
        languages: [] as Language[],
        currentLanguage: null as Language | null,

        helpdeskLoaded: false,
        languagesLoaded: false
    }),

    actions: {
        setHelpdesk(helpdesk: Helpdesk[]) {
            this.helpdesk = helpdesk
        },
        setCurrentHelpdesk(helpdesk: Helpdesk | null) {
            this.currentHelpdesk = helpdesk
        },
        setLanguages(languages: Language[]) {
            this.languages = languages
        },
        setCurrentLanguage(language: Language | null) {
            this.currentLanguage = language
        },
        async init() {
            await this.fetchHelpdesk();
            await this.fetchLanguages();
        },
        async fetchHelpdesk(force = false) {
            if (this.helpdeskLoaded && !force) return

            const { $api } = useNuxtApp();

            await $api.get("/helpdesks")
                .then((response) => {
                    this.setHelpdesk(response.data);
                    this.setCurrentHelpdesk(response.data);
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.helpdeskLoaded = true;
                })

        },
        async fetchLanguages(force = false) {
            if (this.languagesLoaded && !force) return

            const { $api } = useNuxtApp();

            await $api.get(`/helpdesks/${this.currentHelpdesk?.id}/languages`)
                .then((response) => {
                    this.setLanguages(response.data);

                    this.setCurrentLanguage(response.data.find((language: Language) => language.is_default));
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.languagesLoaded = true;
                })
        },
        clear() {
            this.helpdesk = []
            this.currentHelpdesk = null
            this.languages = []
            this.currentLanguage = null
        }
    }
})